module.exports = __webpack_public_path__ + "img/bg-sect-1.0e758c6b.png";